import React from 'react';

import { observer } from 'mobx-react';

import { Footer } from '../../../../components/Footer/Footer';
import { useJackpotStart } from '../../../../components/GamesList/useJackpotStart';
import classes from '../../../../components/headers/Headers.module.scss';
import { useHeaderHeight } from '../../../../components/headers/useHeaderHeight';
import { Loader } from '../../../../components/Loader/Loader';
import { useHomeResetScroll } from '../../../../pages/Home/useHomeResetScroll';
import { useStores } from '../../../../stores/useStores';
import { useIntercomBodyMargin, useLobbyMainView } from '../../hooks';
import { GamesHero } from '../GamesHero/GamesHero';
import { GamesView } from '../GamesView/GamesView';
import { LobbyCategoriesBar } from '../LobbyCategoriesBar/LobbyCategoriesBar';
import { Widgets } from '../Widgets/Widgets';

import styles from './LobbyMainView.module.scss';

function LobbyMainViewComponent() {
  const { coinTypeStore } = useStores();
  const { coinType } = coinTypeStore;
  const { isScrolled, handleScroll } = useLobbyMainView({ coinType });
  const { headerHeight } = useHeaderHeight();
  useHomeResetScroll();
  useJackpotStart();

  const isHeaderReady = headerHeight > 0;
  // Intercom's banner pushes the page down via a body margin; offset the
  // fixed-height lobby by it so it stays aligned. See useIntercomBodyMargin.
  const intercomBodyMargin = useIntercomBodyMargin();

  return (
    <div className={styles.container} style={{ top: `-${intercomBodyMargin}` }}>
      <div className={styles.headerScrollGradientContainer} style={{ opacity: isScrolled ? 1 : 0 }}>
        <div
          className={`${styles.headerScrollGradient} ${
            coinType === 'GC' ? styles.headerScrollGradientGC : styles.headerScrollGradientSC
          }`}
        />
      </div>
      <div className={coinType === 'GC' ? styles.headerBackgroundGCOuter : classes.headerScrollBackgroundSCOuter}>
        <div className={styles.headerBackgroundInner} />
      </div>
      {isHeaderReady ? (
        <div className={styles.contentWrapper} onScroll={handleScroll}>
          <div className={styles.topContent}>
            <GamesHero />
            <Widgets />
          </div>
          <LobbyCategoriesBar />
          <GamesView />
          <Footer />
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
}

export const LobbyMainView = observer(LobbyMainViewComponent);
